﻿import React, { useState, useEffect } from 'react';
import { FtirBenchSheet } from '../models/ftir-bench-sheet';
import SpectralFilesComponent from './SpectralFilesComponent';
import SpectralGraph from './SpectralGraph';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { FtirAnalysisType, ModalMessageType } from '../models/enums';
import { CrudFunctions } from '../utilities/crud-functions';
import { ToastProps } from '../models/toast-props';

import { Toast } from 'devextreme-react/toast';
import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

export interface Props {
    benchSheetId: string;
    ftirAnalysisType: FtirAnalysisType;
    isReadOnly: boolean;    
    headerBgClass?: string;
}

export default function FtirDataComponent(props: Props) {
    const [benchSheet, setBenchSheet] =
        useState<FtirBenchSheet>();

    // ??
    const [spectralGraphUpdateKey, setSpectralGraphUpdateKey] =
        useState<number>(1);

    const [spectralImageDialogVisible, setSpectralImageDialogVisible] =
        useState<boolean>()

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, [props.benchSheetId]);

    const productName = benchSheet && benchSheet.spectralImageProductName ?
        benchSheet.spectralImageProductName : '';

    const batchName = benchSheet && benchSheet.batchName ?
        benchSheet.batchName : '';

    const spectralImageName = `${productName} ${batchName}`;

    return (
        <div>
            <div id="spectralFilesComponent">
                <SpectralFilesComponent benchSheetId={props.benchSheetId}
                    isReadOnly={props.isReadOnly}
                    ftirAnalysisType={props.ftirAnalysisType}
                    onSpectralDataChanged={onSpectralDataChanged}
                    headerBgClass={props.headerBgClass} />
            </div>

            <Button className="pw-margin-top-05 pw-margin-left-05"
                text="Show Spectral Image" icon="image" type="success"
                hint="show spectral image"
                onClick={showSpectralImage} />

            {spectralImageDialogVisible &&
                <DialogPopup visible={spectralImageDialogVisible}
                    onHiding={hideSpectralImage}
                    title="Spectral Image"
                    fullScreen={true} >
                    <SpectralGraph benchSheetId={props.benchSheetId}
                        ftirAnalysisType={props.ftirAnalysisType}
                        isReadOnly={props.isReadOnly}
                        spectralImageName={spectralImageName}
                        updateKey={spectralGraphUpdateKey}
                        onClose={onSpectralGraphClose} />
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onSpectralGraphClose() {
        setSpectralImageDialogVisible(false);
    }

    function onSpectralDataChanged() {
        setSpectralGraphUpdateKey(spectralGraphUpdateKey + 1);
    }

    async function getBenchSheet() {
        await CrudFunctions.getData(`benchsheets/benchsheet/${props.benchSheetId}`)
            .then(data => {
                setBenchSheet(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error retrieving FTIR Basic Bench Sheet Data");
            });
    }
       
    async function getAllData() {
        await getBenchSheet();
    }

    function showSpectralImage() {
        setSpectralImageDialogVisible(true);
    }

    function hideSpectralImage() {
        setSpectralImageDialogVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

   

}
